/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getCurrencies = /* GraphQL */ `
  query GetCurrencies {
    getCurrencies {
      CurrencyCode
      CurrencyName
      id
    }
  }
`;
export const getCurrenciesById = /* GraphQL */ `
  query GetCurrenciesById($currencyId: String!) {
    getCurrenciesById(currencyId: $currencyId) {
      CurrencyCode
      CurrencyName
      id
    }
  }
`;
export const getAppConfig = /* GraphQL */ `
  query GetAppConfig {
    getAppConfig {
      id
      minimumAppVersion
      disableTMC
      disableTI
      tiStartDate
      tiEndDate
      tmcStartDate
      tmcEndDate
      appFuncStartDate
      appFuncEndDate
      disableApp
      disableTIPurchase
      disableTICancellation
      disabledMessageTMC
      disabledMessageTI
      disabledMessageApp
      disabledMessageTIPurchase
      disabledMessageTICancellation
    }
  }
`;
export const getAppConfigById = /* GraphQL */ `
  query GetAppConfigById($appConfigId: String!) {
    getAppConfigById(appConfigId: $appConfigId) {
      id
      minimumAppVersion
      disableTMC
      disableTI
      tiStartDate
      tiEndDate
      tmcStartDate
      tmcEndDate
      appFuncStartDate
      appFuncEndDate
      disableApp
      disableTIPurchase
      disableTICancellation
      disabledMessageTMC
      disabledMessageTI
      disabledMessageApp
      disabledMessageTIPurchase
      disabledMessageTICancellation
    }
  }
`;
export const getErrorMessages = /* GraphQL */ `
  query GetErrorMessages {
    getErrorMessages {
      id
      ErrorKey
      ErrorNumber
      ErrorDescription
      InAppErrorMessage {
        title
        body
      }
    }
  }
`;
export const getErrorMessagesById = /* GraphQL */ `
  query GetErrorMessagesById($errorMessagesId: String!) {
    getErrorMessagesById(errorMessagesId: $errorMessagesId) {
      id
      ErrorKey
      ErrorNumber
      ErrorDescription
      InAppErrorMessage {
        title
        body
      }
    }
  }
`;
export const getMessages = /* GraphQL */ `
  query GetMessages {
    getMessages {
      id
      Title
      Headline
      Summary
      Description
      StartDate
      EndDate
      Active
      TMCUsers
      TIUsers
      Renewals
      GuestUsers
      LoggedInUsers
      AllUsers
      Marketing
      MatchAll
      HasCTAButton
      IsWebLink
      WebLinkURL
      ButtonLabel
      CallToActionText
      CallToActionType
      CallToActionBtnColor
    }
  }
`;
export const getMessagesById = /* GraphQL */ `
  query GetMessagesById($messagesId: String!) {
    getMessagesById(messagesId: $messagesId) {
      id
      Title
      Headline
      Summary
      Description
      StartDate
      EndDate
      Active
      TMCUsers
      TIUsers
      Renewals
      GuestUsers
      LoggedInUsers
      AllUsers
      Marketing
      MatchAll
      HasCTAButton
      IsWebLink
      WebLinkURL
      ButtonLabel
      CallToActionText
      CallToActionType
      CallToActionBtnColor
    }
  }
`;
export const getPolicy = /* GraphQL */ `
  query GetPolicy {
    getPolicy {
      id
      policyType
      header
      body
      isActive
    }
  }
`;
export const getPolicyById = /* GraphQL */ `
  query GetPolicyById($policyId: String!) {
    getPolicyById(policyId: $policyId) {
      id
      policyType
      header
      body
      isActive
    }
  }
`;
export const getPushNotification = /* GraphQL */ `
  query GetPushNotification {
    getPushNotification {
      pushNotification {
        id
        name
        title
        scheduleId
        body
        deeplink
        dueOn
        throttleRate
        autoPauseSchedule
        pauseSendingTime
        resumeSendingTime
        application
        tmcUsers
        tiUsers
        deviceOS
        status
      }
      allSchedules {
        schedules {
          scheduleId
          appName
          notificationName
          deviceAttr
          notificationMsg {
            notification {
              title
              body
            }
          }
          subscriptions {
            tmcUsers
            tiUsers
          }
          createdOn
          updatedOn
          dueOn
          completedOn
          status
          numOptedOut
          numSuccess
          numFailure
          throttleRate
          pauseSendingTime
          resumeSendingTime
        }
      }
    }
  }
`;
export const getPushNotificationById = /* GraphQL */ `
  query GetPushNotificationById($pushNotificationId: String!) {
    getPushNotificationById(pushNotificationId: $pushNotificationId) {
      id
      name
      title
      scheduleId
      body
      deeplink
      dueOn
      throttleRate
      autoPauseSchedule
      pauseSendingTime
      resumeSendingTime
      application
      tmcUsers
      tiUsers
      deviceOS
      status
    }
  }
`;
